import axios from 'axios'
import qs from "qs"
import { Toast, Dialog } from 'vant'
import router from '@/router'
import api from "../interface/index"

let loadingCount = 0;
const client = axios.create({ timeout: 15000 });

export const showLoading = () => {
	if (loadingCount <= 0) Toast.loading({ duration: 20000 });
	loadingCount++;
};

export const hideLoading = () => {
	loadingCount = Math.max(loadingCount - 1, 0);
	if (loadingCount === 0) Toast.clear();
};

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
const retryablePaths = ['/index/webconfig', '/user/info', '/user/funds', '/user/my_bank', '/user/real_auth_info'];

const isRetryable = error => {
	if (!error || !error.response) return true;
	return [502, 503, 504].includes(error.response.status);
};

const send = async (config, retries) => {
	let lastError;
	for (let attempt = 0; attempt <= retries; attempt++) {
		try {
			return await client(config);
		} catch (error) {
			lastError = error;
			if (attempt >= retries || !isRetryable(error)) throw error;
			await wait(400 * (attempt + 1));
		}
	}
	throw lastError;
};

export default async (path, data = {}, opt = {}, isLoad = true) => {
	const token = localStorage.getItem('token');
	const method = (opt && opt.method) || 'post';
	const retries = opt && Number.isInteger(opt.retries) ? opt.retries : (retryablePaths.includes(path) ? 1 : 0);
	const url = api.commonUrl + "/api" + path;
	const payload = { ...data, token };
	const config = { ...opt, method, url };
	delete config.retries;
	if (method.toLowerCase() === 'post') config.data = payload;
	else config.url += '?' + qs.stringify(payload);

	if (isLoad) showLoading();
	try {
		const response = await send(config, retries);
		const result = response && response.data;
		if (!result || typeof result.code === 'undefined') throw { msg: '网络错误，请稍后重试！' };
		if (result.code === 1) return result;

		if (result.code === 406 && router.currentRoute.path !== '/setpaypwd') {
			router.push('/setpaypwd').catch(() => {});
		}
		if (result.code === 410 && router.currentRoute.path !== '/setpaypwd') {
			const redirect = router.currentRoute.fullPath;
			router.push({ path: '/setpaypwd', query: { redirect } }).catch(() => {});
		}
		if (result.code === 412 && router.currentRoute.path !== '/realAuth') {
			const redirect = router.currentRoute.fullPath;
			router.replace({ path: '/realAuth', query: { redirect } });
		}
		if (result.code === 403 || result.code === 401) {
			localStorage.removeItem('token');
			if (result.code === 401) localStorage.setItem('reset_time', 0);
			const current = { ...router.currentRoute };
			if (current && current.path !== '/login' && !['/', '/reg', '/forgetpwd'].includes(current.path)) {
				router.replace('/login?redirect=' + current.path);
			}
		}
		throw result;
	} catch (error) {
		let message = '网络连接不稳定，请稍后重试！';
		if (error && error.code === 'ECONNABORTED') message = '请求超时，请检查网络后重试！';
		const info = error && error.info ? (typeof error.info === 'object' ? error.info.zh_cn : error.info) : '';
		const msg = error && error.msg ? (typeof error.msg === 'object' ? error.msg.zh_cn : error.msg) : '';
		if (info) message = info;
		if (msg) message = msg;
		if (isLoad) Dialog.alert({ message, confirmButtonText: window.vm.$i18n.t('utils.confirm') }).catch(() => {});
		throw error;
	} finally {
		if (isLoad) hideLoading();
	}
};
